import { Card, Flex, Spin, Typography, theme } from 'antd'
import React, { useEffect, useState } from 'react'

import { useAuth } from '@hooks/useAuth'
import { HandWavingIcon } from '@phosphor-icons/react'

async function sleep(ms: number): Promise<void> {
    return new Promise(resolve => {
        setTimeout(resolve, ms)
    })
}

const animations = `
@keyframes logout-fade-in {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}
@keyframes logout-wave {
    0%, 60%, 100% { transform: rotate(0deg); }
    10%, 30% { transform: rotate(14deg); }
    20% { transform: rotate(-8deg); }
    40% { transform: rotate(-4deg); }
    50% { transform: rotate(10deg); }
}
`

export const LogoutPage: React.FC = () => {
    const { user, logout } = useAuth()
    const { token } = theme.useToken()

    // Capture the name before logout clears the user.
    const [firstName] = useState(() => user?.firstName)

    useEffect(() => {
        const out = async () => {
            await logout()

            await sleep(300) // just to so you can see the good bye message

            window.location.href = '/login'
        }
        out()
    }, [])

    return (
        <Flex justify="center" align="center" style={{ minHeight: '60vh' }}>
            <style>{animations}</style>
            <Card
                style={{ width: '100%', maxWidth: 400, animation: 'logout-fade-in 300ms ease-out' }}
                styles={{ body: { padding: 32 } }}
            >
                <Flex vertical align="center" gap="middle">
                    <Flex
                        align="center"
                        justify="center"
                        style={{
                            width: 64,
                            height: 64,
                            borderRadius: '50%',
                            background: token.colorPrimaryBg
                        }}
                    >
                        <HandWavingIcon
                            size={32}
                            weight="duotone"
                            color={token.colorPrimary}
                            style={{ animation: 'logout-wave 1.6s ease-in-out infinite', transformOrigin: '70% 70%' }}
                        />
                    </Flex>
                    <Flex vertical align="center" gap="xsmall">
                        <Typography.Title level={3} style={{ margin: 0 }}>
                            {firstName ? `See you soon, ${firstName}` : 'See you soon'}
                        </Typography.Title>
                        <Typography.Text type="secondary">You've been signed out of Pomegranate Admin</Typography.Text>
                    </Flex>
                    <Spin size="small" />
                </Flex>
            </Card>
        </Flex>
    )
}
